// extracted by mini-css-extract-plugin
export default {"desktop":"style_desktop__41wQI","mobile":"style_mobile__Lc26y","laptop":"style_laptop__vY4wI","v3":"style_v3__7LsPU"};